export default function PreviousRound({ id, previous, onBack }) {

    return (
        <div className="container mt-3">
            {
                onBack && (
                    <div id="bread-container" className="mb-3">
                        <a className="bread-anchor" id="bread-acr" onClick={onBack} style={{ cursor: 'pointer' }}>
                            ← Back
                        </a>
                    </div>
                )
            }
            
            <h3>Previous Rounds</h3>

            {previous.length === 0 ? (
                <p>No previous rounds available.</p>
            ) : (
                previous.map((round, index) => (
                    <div key={round.id} className="card p-3 my-3 shadow-sm">
                        <h5 className="mb-2">Level {round.level_number}</h5>

                        <div className="row">
                            <div className="col-md-6">
                                <p><strong>Interview Date:</strong> {round.interview_date}</p>
                                <p><strong>Interview Time:</strong> {round.interview_time}</p>
                                <p><strong>Interviewer:</strong> {round.interviewer_name}</p>
                                <p><strong>Status:</strong> {round.status}</p>
                                <p><strong>Remarks:</strong> {round.remarks}</p>
                            </div>

                            <div className="col-md-6">
                                <h6 className="fw-bold">Technical Assessment</h6>
                                <ul className="list-unstyled mb-0">
                                    <li className="py-2"><strong>Qualification:</strong> {round.tech_qualification|| 'No data'}</li>
                                    <li className="py-2"><strong>Experience:</strong> {round.tech_experience|| 'No data'}</li>
                                    <li className="py-2"> <strong>Knowledge:</strong> {round.tech_knowledge|| 'No data'}</li>
                                    <li className="py-2"><strong>Skills:</strong> {round.tech_skills_rating || 'No data'}</li>
                                    <li className="py-2"><strong>Attitude:</strong> {round.tech_attitude|| 'No data'}</li>
                                    <li className="py-2"><strong>Communication:</strong> {round.tech_communication|| 'No data'}</li>
                                    <li className="py-2"><strong>Time Management:</strong> {round.tech_time_management|| 'No data'}</li>
                                    <li className="py-2"><strong>Flexibility:</strong> {round.tech_flexibility|| 'No data'}</li>
                                    <li className="py-2"><strong>Commitment:</strong> {round.tech_commitment|| 'No data'}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
}
